// src/Config/Colors.jsx
// src/Config/Colors.jsx
// css example 
//  color: var(--color1);

//  style example 
//     background: `${Colors.color7}`,

const themes = {
  BlueRedYellow: {
    color1: "#424242",
    color2: "#00000040",
    color3: "#6A6A6A",
    color4: "#D9D9D9",
    color5: "rgba(255, 255, 255, 0.6)",
    color7: "#D9D9D9",
    color8: "#F6F6F6",
    color9: "#D6D6D6",
    color10: '#FBFBFB',
    color11: "#00000040",
    color12: "#0095FF",
    color13: "#DEEDFF",
    color14: "#FFFFFF",
    color15: "#FA4741",
    color16: "#7851A9 ",
    color17: "#FFBD20 ",
    color18: "#337AB7",
    color19: "#FFF1D1",
    opacity: 0.6,
  },
  DarkMode: {
    color1: "#d2cf00ff",
    color2: "#97000088",
    color3: "#4d0606ff",
    color4: "#00ba0cff",
    color5: "rgba(30, 30, 30, 0.6)",
    color6: "#d2cf00ff",
    color7: "#97000088",
    color8: "#4d0606ff",
    color9: "#00ba0cff",
    opacity: 0.4,
  },
};

// Change this value only to switch theme globally
const currentThemeName = "BlueRedYellow";
const currentTheme = themes[currentThemeName];

// Inject CSS variables globally
if (typeof document !== "undefined") {
  Object.entries(currentTheme).forEach(([key, value]) => {
    document.documentElement.style.setProperty(`--${key}`, value);
  });
}

const Colors = currentTheme;
export default Colors;

// this version of code is working for both css and style so continueing with this for future will require changes example below
// branch-div-landing {
//   color:var(--color7);
//   display: flex;
//   flex-direction: column;
//   align-items: flex-start; /* This will align the text to the left */
//   height: 100%;
//   width: auto;
//   border-left: 45px solid transparent;
//   border-top: 15px solid transparent;
// }

// const themes = {
//     BlueRedYellow: {
//         color1: "#424242",
//         color2: "#00000040",
//         color3: "#6A6A6A",
//         color4: "#D9D9D9",
//         color5: "rgba(255, 255, 255, 0.6)",
//         opacity: 0.6,
//         color6: "#ffbd20",
//         color7: "#c8d8e4",
//     },
//     DarkMode: {
//         color1: "#FAFAFA",
//         color2: "#44444488",
//         color3: "#BBBBBB",
//         color4: "#333333",
//         color5: "rgba(30, 30, 30, 0.6)",
//         opacity: 0.4,
//     },
// };

// const currentThemeName = "BlueRedYellow";
// const currentTheme = themes[currentThemeName];

// // Inject CSS variables
// if (typeof document !== "undefined") {
//     Object.entries(currentTheme).forEach(([key, value]) => {
//         document.documentElement.style.setProperty(`--${key}`, value);
//     });
// }

// const Colors = currentTheme;
// export default Colors;
